import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeStorageService } from './theme-storage.service';
import { UiThemeService } from './ui-theme.service';

@NgModule({
  imports: [CommonModule],
  providers: [UiThemeService, ThemeStorageService],
})
export class ArmorMaterialModule {}
